export class AuctionModel {
    Id: number;
    AuctionStatusId: number;
    Title: string;
    OpenDate: Date;
    CloseDate: Date;
    SubmissionDeadline: Date;

    get IsOpen(): boolean {
        return this?.AuctionStatusId === 1;
    }

    get HasExpired(): boolean {
        return this?.CloseDate < new Date();
    }

    constructor() {
        this.Title = "";
    }
}